import { selectActiveContentViewerContextMatches } from '@/content-viewer/store/selectors'
import { ViewerOpenContextKind } from '@/content-viewer/store/schemas'

import { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'

export type AgentResponseReferencesListItemHighlightButtonProps = {
  citation_id: string
  citationHighlightIndex: number
  citationLabel: string
  disabled?: boolean
  onClick: (citationHighlightIndex?: number) => void
}

export default function AgentResponseReferencesListItemHighlightButton(props: AgentResponseReferencesListItemHighlightButtonProps) {
  const { citation_id, citationHighlightIndex, citationLabel, disabled = false, onClick } = props

  const isActive = useAppSelector((state: RootState) =>
    selectActiveContentViewerContextMatches(state, {
      kind: ViewerOpenContextKind.CHAT_CITATION,
      citationId: citation_id,
      highlightIndex: citationHighlightIndex,
    })
  )

  return (
    <button
      disabled={disabled}
      className={`text-brand-700 hover:text-brand-800 hover:underline whitespace-nowrap disabled:cursor-wait disabled:text-brand-neutral-500 ${
        isActive ? 'font-bold' : ''
      }`}
      onClick={() => onClick(citationHighlightIndex)}
    >
      [{citationLabel}]
    </button>
  )
}
